import { isNullish, omit } from 'remeda';

import { PromoCodeType } from 'v2/constants';

export const DEFAULT_PROMO_CODE_COUNT = 1;
export const MIN_PROMO_CODE_COUNT = 1;
export const MAX_PROMO_CODE_COUNT = 100;

interface PromoCodeCountForm {
  type: PromoCodeType;
  count?: number;
}

export const getPromoCodeCountByType = (type: PromoCodeType): number | undefined =>
  type === PromoCodeType.CONTEST_TICKET ? DEFAULT_PROMO_CODE_COUNT : undefined;

export const buildPromoCodePayload = <T extends PromoCodeCountForm>(values: T): T => {
  if (values.type !== PromoCodeType.CONTEST_TICKET || isNullish(values.count)) {
    return omit(values, ['count']) as T;
  }

  return { ...values, count: Number(values.count) };
};
